<section class="p-2 p-md-4">

  <div *ngIf="listaTipoUnidade.length>0" class="card">
    <div class="table-responsive">

      <div class="row">
        <p-table #dt [columns]="cols"
          styleClass="p-datatable-responsive-demo table table-striped table-hover table-responsive-md"
          [value]="listaTipoUnidade" exportFilename={{dynamicdownloadName}} csvSeparator=";" selectionMode="single"
          [(selection)]="unidade" [first]="first">

          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of cols" [pSortableColumn]="col.field">
                {{col.header}}
                <p-sortIcon [field]="col.field" class="alignRight"></p-sortIcon>
              </th>
              <th  style="width: 15%;" *ngIf="usuario.permissoes.administrador" class="justify-content-end">
                
                <span data-toggle="tooltip" data-placement="bottom" title="Adicionar Tipo d Unidade">
                  <button type="button" pButton pRipple  icon="pi pi-plus" (click)="cadastrar()" class="btn btn-md btn-success" style="width: 45%;">
                  </button>
                </span>
              <div style="margin-left: 10%;display: inline;"></div>
              <span data-toggle="tooltip" data-placement="bottom" title="Exportar página em CSV">
                <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="dt.exportCSV()" style="width: 45%;"
                  class="btn btn-md btn-success" pTooltip="CSV" tooltipPosition="bottom"></button>
                </span>

            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-rowData let-columns="columns" let-index="index" let-rowIndex="rowIndex">
            <tr [pSelectableRow]="rowData">

              <td>{{rowData.nome}}</td>
            <td>{{rowData.nivel}}</td>
            <td>{{rowData.descricao}}</td>
            <td class="py-0 text-right" *ngIf="usuario.permissoes.administrador">
              <div class="d-flex justify-content-center">
                <span data-toggle="tooltip" data-placement="bottom" title="Editar">
                <button (click)="editar(rowData.id)" class="btn-sm btn-info btn btn-icon">
                  <i class="mdi mdi-pencil"></i>
                </button>
              </span>
              </div>
            </td>

            </tr>
          </ng-template>
          
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length + 1">
                Nenhum resultado foi encontrado
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>

    </div>
  </div>
</section>